// const { randomBytes, createHash } = require('crypto')
// // Cognito Configuration
// export const generatePKCEPair = () => {
//     const bytes = 22
//     const hashAlg = 'sha256'
    // const randomVerifier = randomBytes(bytes).toString('hex')
//     const hash = createHash(hashAlg).update(randomVerifier).digest('base64')
//     const challenge = hash.replace(/\+/g, '-').replace(/\//g,'-').replace(/=+$/,'')
//     return {verifier: randomVerifier, challenge}
// }
export const cognito_client_id = '5leheampiobhkra0iu2df36tif';
export const cognito_redirect_uri = `${(window as any)._env_.REACT_APP_FRONTEND}/cognito`;
export const cognito_response_type = 'code';
export const cognito_scope = 'email openid phone';
export const cognito_authority = 'https://aacounty.auth.us-east-1.amazoncognito.com';
// export const cognito_challenge = generatePKCEPair().challenge
// export const cognito_verifier = generatePKCEPair().verifier